import './scss/index.scss';
import { dcFactory } from 'dc';
import ImageGalleryComponent from './js/image-gallery.component';

dcFactory.register(ImageGalleryComponent);
